import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { useLeftBar } from "../../../context/LeftBar";
import { useLocation } from "react-router-dom";
import { Grid } from "@mui/material";

function NavItem({ icon, muiIcon, name, path, subpages }) {
	const { leftBarOpened } = useLeftBar();
	const [showSubPageItems, setShowSubPageItems] = useState(false);
	const location = useLocation();

	useEffect(() => {
		if (
			subpages &&
			subpages.some((s) => s.url === location.pathname) &&
			!showSubPageItems
		) {
			setShowSubPageItems(true);
		}
	}, [location.pathname]);

	return (
		<div className={`navItem ${leftBarOpened ? "open" : "closed"}`}>
			<NavLink
				to={path}
				activeClassName="active"
				isActive={(match, location) => {
					return subpages
						? subpages.some(
								(subpage) => subpage.url === location.pathname
						  )
						: path === location.pathname;
				}}
				onClick={(e) => {
					if (subpages) {
						e.preventDefault();
						setShowSubPageItems(!showSubPageItems);
					}
				}}
			>
				{leftBarOpened ? (
					<Grid
						container
						flexDirection={"row"}
						justifyContent={"flex-start"}
						alignItems={"center"}
					>
						<Grid item>
							{icon ? <i className={`${icon}`} /> : muiIcon}
						</Grid>
						<Grid item>
							<span
								className={
									leftBarOpened
										? "navItemName"
										: "navItemName is-hidden"
								}
							>
								{name}
							</span>
						</Grid>
					</Grid>
				) : (
					<Grid
						container
						flexDirection={"row"}
						justifyContent={"center"}
						alignItems={"center"}
						item
					>
						{icon ? <i className={`${icon}`} /> : muiIcon}
					</Grid>
				)}
			</NavLink>
			{subpages && leftBarOpened && (
				<>
					<i
						className={
							showSubPageItems
								? "fal fa-angle-up"
								: "fal fa-angle-down"
						}
					/>
					<ul
						className={
							showSubPageItems
								? "subPagesList showSubPageItems"
								: "subPagesList"
						}
					>
						{showSubPageItems &&
							subpages.map((subpage) => (
								<li className="subNavItems" key={subpage.id}>
									<NavLink
										className="subNavLink"
										to={subpage.url}
										activeClassName="subItemActive"
									>
										{subpage.name}
									</NavLink>
								</li>
							))}
					</ul>
				</>
			)}
		</div>
	);
}

NavItem.defaultProps = {
	icon: "",
	name: "",
	path: "",
	subpages: undefined,
};

NavItem.propTypes = {
	icon: PropTypes.string,
	name: PropTypes.string,
	path: PropTypes.string,
	subpages: PropTypes.array,
};

export default NavItem;
